module.exports = __webpack_public_path__ + "img/sad.6d6da072.png";